import { iIconProps } from '../icon';

export default function ArrowRightIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                d='M20.64 10.89c-.18-.3-.42-.6-.67-.89-.51-.58-1.18-1.2-1.81-1.75-.64-.56-1.28-1.07-1.76-1.44-.24-.18-.66-.5-.8-.61a.996.996 0 0 0-1.4.21c-.33.44-.23 1.07.21 1.4.13.1.53.4.76.58.46.36 1.07.85 1.68 1.38.48.42.94.84 1.32 1.24H4c-.55 0-1 .45-1 1s.45 1 1 1h14.17c-.38.4-.84.82-1.32 1.24-.61.53-1.22 1.02-1.68 1.38-.23.18-.63.48-.76.58-.44.33-.54.95-.21 1.4.33.44.95.54 1.4.21.14-.11.56-.43.8-.61.48-.37 1.12-.89 1.76-1.44s1.3-1.17 1.81-1.75c.25-.29.49-.59.67-.89.16-.27.36-.67.36-1.11s-.19-.84-.36-1.11Z'
                fill='currentColor'
            />
            <path
                d='M15.31 18.25c-.32 0-.64-.12-.88-.37a1.25 1.25 0 0 1 0-1.77l3.94-3.94c.06-.06.07-.13.07-.18s-.01-.12-.07-.18l-3.94-3.94c-.49-.49-.49-1.28 0-1.77s1.28-.49 1.77 0l3.94 3.94c.52.52.81 1.21.81 1.94s-.29 1.42-.81 1.94l-3.94 3.94c-.24.24-.56.37-.88.37Z'
                fill='currentColor'
            />
            <path
                d='M19.68 13.25H4.31a1.25 1.25 0 0 1 0-2.5h15.37a1.25 1.25 0 0 1 0 2.5'
                fill='currentColor'
            />
        </svg>
    );
}
